module.exports = __webpack_public_path__ + "img/unilever.b9197b81.png";